import "./AddButton.css";
import React from "react";
import { Link } from "react-router-dom";
import { AiOutlinePlusCircle } from "react-icons/ai";

function AddButton({ text }) {
  const Addpage = [{ name: "add", path: "/Add" }];
  return (
    <div classNme="addbutton">
      {Addpage.map((add, index) => {
        return (
          <Link to={add.path} key={index}>
            <button className="addbutton">
              <AiOutlinePlusCircle />
              {text}
            </button>
          </Link>
        );
      })}
    </div>
  );
}

export default AddButton;
